module.exports = __webpack_public_path__ + "static/media/catalogue-pattern-dark.f9f421e5.png";